import React, {Suspense} from 'react';
import {useSelector} from 'react-redux';
import {selectCurrentUser} from 'app/hooks/reduxCreateSelectorHooks';
const LiverampComponent = React.lazy(() => import('app/components/lazyLoadWrapper/liveramp/LiverampComponent'));

const LiverampLoader = () => {
  const {initializing, user} = useSelector(selectCurrentUser);

  return !initializing && Object.keys(user).length ? (
    <Suspense fallback={null}>
      <LiverampComponent />
    </Suspense>
  ) : null;
};

export default LiverampLoader;
